export const getCardKey = (index, card) => {
  if (card) {
    return card.rank.name.toString()
      + card.suit.name.toString()
      + index;
  }
  return index
};